// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__IDcnh","rotateSpinner":"loader_rotateSpinner__gSat9"};